document.addEventListener('DOMContentLoaded', function () {
    // Coordenadas do endereço: VRS 805 Km 6,8 Linha Amadeu, Pinto Bandeira – RS
    // Pinto Bandeira, Bento Gonçalves - RS
    const latitude = window.map_lat;
    const longitude = window.map_lng;
    const markerIconUrl = window.map_marker;

    console.log(latitude);


    // Cria o mapa no elemento .mapa
    const map = L.map('mapa').setView([latitude, longitude], 15);

    // Adiciona o tile layer (OpenStreetMap)
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        maxZoom: 19
    }).addTo(map);

    // Adiciona um marcador
    const marker = L.marker([latitude, longitude]).addTo(map)
        .bindPopup(`<img src="${markerIconUrl}">`)
        .openPopup();

    // Opcional: Adiciona um círculo ao redor do marcador
    L.circle([latitude, longitude], {
        color: '#CCB258',
        fillColor: '#CCB258',
        fillOpacity: 0.2,
        radius: 500
    }).addTo(map);
});

// Função de máscara de telefone brasileiro
function mascaraTelefone(input) {
    // Remove tudo que não é dígito
    let valor = input.value.replace(/\D/g, '');

    // Limita a 11 dígitos (DDD + 9 dígitos)
    if (valor.length > 11) {
        valor = valor.slice(0, 11);
    }

    // Aplica a máscara conforme o tamanho
    if (valor.length <= 2) {
        // (DD
        input.value = `(${valor}`;
    } else if (valor.length <= 6) {
        // (DD) 9999
        input.value = `(${valor.slice(0, 2)}) ${valor.slice(2)}`;
    } else if (valor.length <= 10) {
        // (DD) 9999-9999 (telefone fixo)
        input.value = `(${valor.slice(0, 2)}) ${valor.slice(2, 6)}-${valor.slice(6)}`;
    } else {
        // (DD) 99999-9999 (celular)
        input.value = `(${valor.slice(0, 2)}) ${valor.slice(2, 7)}-${valor.slice(7, 11)}`;
    }
}

// Aplica a máscara ao campo de telefone
document.addEventListener('DOMContentLoaded', function () {
    const telefoneInput = document.getElementById('telefone');

    if (telefoneInput) {
        // Aplica máscara ao digitar
        telefoneInput.addEventListener('input', function (e) {
            mascaraTelefone(e.target);
        });

        // Formata ao colar conteúdo
        telefoneInput.addEventListener('paste', function (e) {
            setTimeout(() => mascaraTelefone(e.target), 10);
        });

        // Limpa formatação ao focar (opcional - melhora UX para edição)
        telefoneInput.addEventListener('focus', function (e) {
            // Salva valor sem máscara em data attribute
            e.target.dataset.raw = e.target.value.replace(/\D/g, '');
        });

        // Restaura máscara ao perder foco
        telefoneInput.addEventListener('blur', function (e) {
            mascaraTelefone(e.target);
        });
    }
});